import regeneratorRuntime from "/app/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState, useMemo } from 'react';
import { useRouter } from 'next/router';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import WrapPage from '@/components/base/Layout/wrap';
import TransactionTree from '@/components/combined/TransactionTree';
import Icon from '@/components/base/Icon';
import Toast from '@/components/base/Toast';
import Linker from '@/components/base/Linker';
import Descriptions from '@/components/base/Descriptions';
import BlockHeightLink from '@/components/combined/BlockHeightLink';
import useLanguage from '@/hooks/useLanguage';
import getTxService from '@/api/transactions';
import getOverview from '@/api/overview';
import { makeAddressInfo, makeShardDetailLink, makeTxDetailLink } from '@/utils/link';
import { toDio, toShard, toShardCount, toUTCTime } from '@/utils/string';
import { getTargetAddressByTxnDetail, TRANSACTION_STATUS_SUCCESS, TRANSACTION_STATUS, TXN_PK_RELAY_GROUP } from '@/constants/Transaction';
import refreshStore from '@/store/Refresh';
import { observer } from 'mobx-react-lite';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var tx = getTxService();
var overviewService = getOverview();
var Transaction = function() {
    var ref6;
    var router = useRouter();
    var ref1 = useLanguage(), gettext = ref1.translate;
    var ref2 = useState(), txData = ref2[0], setTxData = ref2[1];
    var ref3 = useState(''), targetAddress = ref3[0], setTargetAddress = ref3[1];
    var ref4 = useState(''), status = ref4[0], setStatus = ref4[1];
    var ref5 = useState(true), loading = ref5[0], setLoading = ref5[1];
    var TxHash = router === null || router === void 0 ? void 0 : (ref6 = router.query) === null || ref6 === void 0 ? void 0 : ref6.hash;
    var refresh = refreshStore.refresh;
    useEffect(function() {
        if (refresh) {
            getDetail(TxHash);
        }
    }, [
        refresh
    ]);
    useEffect(function() {
        getDetail(TxHash);
    }, [
        TxHash,
        router
    ]);
    useEffect(function() {
        getTargetAddressByTxnDetail(txData).then(setTargetAddress);
        if (txData === null || txData === void 0 ? void 0 : txData.ConfirmState) {
            var statusStr = TRANSACTION_STATUS[txData.ConfirmStateOverride || txData.ConfirmState];
            if (statusStr === TRANSACTION_STATUS.TXN_CONFIRMED) {
                getConfirmed();
            } else {
                setStatus(statusStr);
            }
        }
    }, [
        txData
    ]);
    var getDetail = useCallback(function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(hash) {
            var detail;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!hash) {
                            _ctx.next = 14;
                            break;
                        }
                        setLoading(true);
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return tx.getTxDetail(hash);
                    case 5:
                        detail = _ctx.sent;
                        setTxData(detail);
                        setLoading(false);
                        _ctx.next = 14;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](2);
                        setLoading(false);
                        Toast.error(_ctx.t0);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    10
                ]
            ]);
        }));
        return function(hash) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var handleCopy = useCallback(function() {
        Toast({
            content: 'Copied'
        });
    }, []);
    var getConfirmed = useCallback(function() {
        overviewService.getOverview().then(function(r) {
            var ref = r.Result || {}, _Height = ref.Height, Height = _Height === void 0 ? 0 : _Height;
            var num = (Height - ((txData === null || txData === void 0 ? void 0 : txData.Height) || 0)).toFixed(0);
            setStatus("".concat(TRANSACTION_STATUS.TXN_CONFIRMED, " (").concat(num, ")"));
        });
    }, [
        txData
    ]);
    var isRelayGroup = useMemo(function() {
        var ref;
        return (txData === null || txData === void 0 ? void 0 : (ref = txData.Packing) === null || ref === void 0 ? void 0 : ref.match(TXN_PK_RELAY_GROUP)) && !txData.Hash.match(':');
    }, [
        txData
    ]);
    var pendingString = useMemo(function() {
        return !(txData === null || txData === void 0 ? void 0 : txData.Height) ? gettext('Pending') : '';
    }, [
        txData
    ]);
    var rendTargetAddress = useMemo(function() {
        if (!targetAddress) return '';
        var ref = _slicedToArray(targetAddress.split(':'), 2), targetAddressName = ref[0], targetAddressType = ref[1];
        return(/*#__PURE__*/ _jsx(Descriptions.Item, {
            label: gettext('Target Address'),
            skeleton: loading,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ _jsx(Linker, {
                        className: "font-mono font-[400] text-[16px]",
                        href: makeAddressInfo(targetAddress),
                        text: targetAddressName
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-desc bg-[#E5E6EB] rounded-[4px] px-[6px] ml-[4px] mr-[16px] text-[14px]",
                        children: targetAddressType
                    }),
                    /*#__PURE__*/ _jsx(CopyToClipboard, {
                        text: targetAddress,
                        onCopy: handleCopy,
                        children: /*#__PURE__*/ _jsx(Icon, {
                            type: "copy",
                            className: "cursor-pointer text-[16px]"
                        })
                    })
                ]
            })
        }));
    }, [
        targetAddress,
        loading
    ]);
    var isNormalTxn = useMemo(function() {
        return (txData === null || txData === void 0 ? void 0 : txData.ExecStage) === 'XTG_USER_INITIATED';
    }, [
        txData
    ]);
    var rendInitiatorAddress = useMemo(function() {
        var initiator;
        if (isNormalTxn) {
            initiator = (txData === null || txData === void 0 ? void 0 : txData.Signers) ? txData === null || txData === void 0 ? void 0 : txData.Signers[0] : '';
        } else {
            initiator = txData === null || txData === void 0 ? void 0 : txData.Initiator;
        }
        if (!initiator) return '';
        var initiatorArr = initiator.split(':');
        return(/*#__PURE__*/ _jsx(Descriptions.Item, {
            label: gettext('Initiator Address'),
            skeleton: loading,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ _jsx(Linker, {
                        className: "font-mono font-[400] text-[16px]",
                        href: makeAddressInfo(initiator),
                        text: initiatorArr[0]
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-desc bg-[#E5E6EB] rounded-[4px] px-[6px] ml-[4px] mr-[16px] text-[14px]",
                        children: initiatorArr[1]
                    }),
                    /*#__PURE__*/ _jsx(CopyToClipboard, {
                        text: initiator,
                        onCopy: handleCopy,
                        children: /*#__PURE__*/ _jsx(Icon, {
                            type: "copy",
                            className: "cursor-pointer text-[16px]"
                        })
                    })
                ]
            })
        }));
    }, [
        txData,
        loading
    ]);
    var renderOriginateTxn = useMemo(function() {
        if (!(txData === null || txData === void 0 ? void 0 : txData.OrigTxHash)) return '';
        return(/*#__PURE__*/ _jsx(Descriptions.Item, {
            label: gettext('Originate Txn'),
            skeleton: loading,
            children: /*#__PURE__*/ _jsx(Linker, {
                className: "font-mono",
                href: makeTxDetailLink(txData === null || txData === void 0 ? void 0 : txData.OrigTxHash),
                text: txData === null || txData === void 0 ? void 0 : txData.OrigTxHash
            })
        }));
    }, [
        txData,
        loading
    ]);
    var renderShard = useMemo(function() {
        var shard = (txData === null || txData === void 0 ? void 0 : txData.Shard) || (txData === null || txData === void 0 ? void 0 : txData.EmitShard);
        return(/*#__PURE__*/ _jsx(Descriptions.Item, {
            label: gettext('Shard'),
            skeleton: loading,
            children: shard && /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center",
                children: [
                    shard[0] !== undefined && /*#__PURE__*/ _jsx(Linker, {
                        href: makeShardDetailLink(shard[0]),
                        text: toShard(shard[0])
                    }),
                    shard[1] && "(".concat(gettext('Total:')).concat(toShardCount(shard[1]), ")")
                ]
            })
        }));
    }, [
        txData,
        loading
    ]);
    var renderReturnValue = useMemo(function() {
        if (!(txData === null || txData === void 0 ? void 0 : txData.Invocation)) return '';
        var ref = (txData === null || txData === void 0 ? void 0 : txData.Invocation) || {}, Status = ref.Status, _Return = ref.Return, Return = _Return === void 0 ? [] : _Return;
        var returnValue = "".concat(Status, " (").concat(Return[0], ")");
        return(/*#__PURE__*/ _jsxs(Descriptions.Item, {
            label: gettext('Return Value'),
            skeleton: loading,
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: "align-middle",
                    children: pendingString || returnValue || gettext('UnknownError')
                }),
                Status !== TRANSACTION_STATUS_SUCCESS && !pendingString && /*#__PURE__*/ _jsx(Icon, {
                    type: "state-error",
                    className: "text-[13px] ml-[8px] align-middle"
                })
            ]
        }));
    }, [
        txData,
        pendingString,
        loading
    ]);
    var gasfee = useMemo(function() {
        if (typeof (txData === null || txData === void 0 ? void 0 : txData.GasPrice) === 'string' && (txData === null || txData === void 0 ? void 0 : txData.GasOffered)) {
            return Number(txData.GasPrice) * txData.GasOffered;
        }
        return '0';
    }, [
        txData === null || txData === void 0 ? void 0 : txData.GasOffered,
        txData === null || txData === void 0 ? void 0 : txData.GasPrice
    ]);
    var renderGas = useMemo(function() {
        if (isRelayGroup) return '';
        return(/*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Descriptions.Item, {
                    label: gettext('Gas Limit'),
                    skeleton: loading,
                    children: txData === null || txData === void 0 ? void 0 : txData.GasOffered
                }),
                /*#__PURE__*/ _jsx(Descriptions.Item, {
                    label: gettext('Gas Price'),
                    skeleton: loading,
                    children: toDio(txData === null || txData === void 0 ? void 0 : txData.GasPrice, true) || pendingString
                }),
                /*#__PURE__*/ _jsx(Descriptions.Item, {
                    label: gettext('Gas Fees'),
                    skeleton: loading,
                    children: toDio(gasfee, true) || pendingString
                })
            ]
        }));
    }, [
        txData,
        loading,
        pendingString,
        isRelayGroup
    ]);
    return(/*#__PURE__*/ _jsxs("div", {
        className: "my-[20px] w-[100%]",
        children: [
            /*#__PURE__*/ _jsx(Descriptions, {
                title: gettext('Transaction Info'),
                titleClassName: "text-[24px]",
                className: "mb-[40px]",
                children: /*#__PURE__*/ _jsxs(Descriptions.Group, {
                    children: [
                        /*#__PURE__*/ _jsx(Descriptions.Item, {
                            label: gettext('Txn Hash'),
                            skeleton: loading,
                            children: /*#__PURE__*/ _jsx("span", {
                                className: "font-mono",
                                children: txData === null || txData === void 0 ? void 0 : txData.Hash
                            })
                        }),
                        /*#__PURE__*/ _jsx(Descriptions.Item, {
                            label: gettext('Timestamp'),
                            skeleton: loading,
                            children: toUTCTime((txData === null || txData === void 0 ? void 0 : txData.BlockTime) || (txData === null || txData === void 0 ? void 0 : txData.Timestamp) || (txData === null || txData === void 0 ? void 0 : txData.EmitTime))
                        }),
                        /*#__PURE__*/ _jsx(Descriptions.Item, {
                            label: gettext('Status'),
                            skeleton: loading,
                            children: status
                        }),
                        rendTargetAddress,
                        rendInitiatorAddress,
                        renderOriginateTxn,
                        renderShard,
                        /*#__PURE__*/ _jsx(Descriptions.Item, {
                            label: gettext('Block Height'),
                            skeleton: loading,
                            children: pendingString || (txData === null || txData === void 0 ? void 0 : txData.Shard) && (txData === null || txData === void 0 ? void 0 : txData.Height) && /*#__PURE__*/ _jsx(BlockHeightLink, {
                                height: txData === null || txData === void 0 ? void 0 : txData.Height,
                                shardIndex: txData === null || txData === void 0 ? void 0 : txData.Shard[0],
                                isLinker: true
                            })
                        }),
                        renderGas,
                        isNormalTxn && /*#__PURE__*/ _jsx(Descriptions.Item, {
                            label: gettext('ISN'),
                            skeleton: loading,
                            children: String(txData === null || txData === void 0 ? void 0 : txData.ISN) || pendingString
                        }),
                        renderReturnValue
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "text-[18px] leading-[22px] font-[600] mb-[16px] mt-[26px]",
                children: gettext('Transaction Invocation Flow')
            }),
            /*#__PURE__*/ _jsx(TransactionTree, {
                data: txData,
                className: "w-[100%] h-[330px]"
            })
        ]
    }));
};
export default WrapPage(observer(Transaction));
